import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingRubricSuggestionHintFlow = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const { flow: rubricCardFlow } = useFlow(config.frigade.flows.rubricViewAnnouncement);
  const currentStep = flow?.getCurrentStep();

  if (
    (currentStep?.id as OnboardingSteps) === "generate_report" &&
    rubricCardFlow?.isCompleted
  ) {
    return (
      <OnboardingFlow>
        <Frigade.Tour
          flowId={config.frigade.flows.rubricSuggestionHint}
          defaultOpen={true}
          side="right"
          align="center"
          alignOffset={30}
          css={{ paddingLeft: "40px" }}
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingRubricSuggestionHintFlow;
